module.exports = __webpack_public_path__ + "static/img/logo.34df1cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 110